import React, { useContext, useState } from 'react';
import { useStyletron } from 'baseui';
import { FileUploader } from 'baseui/file-uploader';
import { toaster } from 'baseui/toast';
import { MAX_UPLOAD_SIZE, UPLOADED_FILE_ALLOWED_EXTENSIONS } from '@gtintel/platform-constants';
import DocumentList from './DocumentList';
import { DocumentsContext } from './contexts';
import { matchingFileExists } from './utils';

// BaseWeb Uploader accept property needs the extension with the `.`
const UPLOADED_FILE_ALLOWED_EXTENSIONS_DOT = UPLOADED_FILE_ALLOWED_EXTENSIONS.map(ext => `.${ext}`);
const Documents = ({
  canUpload
}) => {
  const {
    addAttachment,
    documentTree
  } = useContext(DocumentsContext);
  const [css] = useStyletron();
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState();
  const [parentFolders, setParentFolders] = useState([]);
  window.addEventListener('beforeunload', () => isUploading);
  return <section className={css({
    display: 'flex',
    flexFlow: 'column',
    gap: '24px',
    margin: '32px 0'
  })}>
      {canUpload && <FileUploader accept={UPLOADED_FILE_ALLOWED_EXTENSIONS_DOT} onCancel={() => setProgress(0)} onDrop={async (acceptedFiles, rejectedFiles) => {
      setIsUploading(true);
      const progressIteration = 100 / acceptedFiles.length;
      setProgress(0.1);
      let uploaded = 0;
      const failed = [];
      for (const file of acceptedFiles) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        let path = file.path.split('/');
        if (path.length > 1) {
          // files in N folders
          path = path.filter(n => n.length > 0).slice(0, -1);
        } else {
          path = [];
        }
        const fullPath = [...parentFolders.map(folder => folder.name), ...path];
        const exists = matchingFileExists(documentTree(), fullPath, file.name);
        if (exists) {
          toaster.negative(`File named ${file.name} already exists in ${fullPath.join('/') ?? 'home'}. Please rename and try again.`);
          failed.push(file);
        } else {
          try {
            await addAttachment(file, 'document', `${fullPath.join('/')}`);
            setProgress(p => {
              return Number((p + progressIteration).toPrecision(2));
            });
            uploaded += 1;
          } catch (e) {
            console.error(e);
            toaster.negative(`Failed to upload ${file.name}`);
            failed.push(file);
          }
        }
      }
      setIsUploading(false);
      if (uploaded > 0) {
        toaster.positive(`Finished uploading ${acceptedFiles.length} file/s.`);
      }
      if (failed.length > 0) {
        toaster.negative(`Failed to upload ${failed.length} file/s.`);
        console.log(`Failed to upload ${failed.length} file`, failed.map(file => file.name));
      }
      if (rejectedFiles.length > 0) {
        toaster.negative(`Failed to upload ${rejectedFiles.length} file/s due to incorrect file type/s.`);
      }
      setProgress(0);
    }} overrides={{
      Root: {
        props: {
          'data-testid': 'file-uploader'
        }
      },
      ContentMessage: () => <div>Drop files or folders here to upload</div>
    }} maxSize={MAX_UPLOAD_SIZE} multiple progressAmount={progress} progressMessage={progress ? `Uploading... ${progress}% of 100%` : ''} />}
      <DocumentList parentFolders={parentFolders} setParentFolders={setParentFolders} setSelectedFolder={setSelectedFolder} selectedFolder={selectedFolder} canUpload={canUpload} />
    </section>;
};
export default Documents;